import React from 'react';
import { capitalize } from '@printu/lang-utils';
import Captcha from '@spectrum-icons/workflow/Captcha';
import Draw from '@spectrum-icons/workflow/Draw';
import Ellipse from '@spectrum-icons/workflow/Ellipse';
import Flashlight from '@spectrum-icons/workflow/Flashlight';
import Image from '@spectrum-icons/workflow/Image';
import Line from '@spectrum-icons/workflow/Line';
import Note from '@spectrum-icons/workflow/Note';
import Rectangle from '@spectrum-icons/workflow/Rectangle';
import TextIcon from '@spectrum-icons/workflow/Text';
import Transparency from '@spectrum-icons/workflow/Transparency';
import ViewDetail from '@spectrum-icons/workflow/ViewDetail';
import * as Icons from 'app/views/components/Icons';
const MakerIcon = {
    Rect: Rectangle,
    Ellipse,
    Line,
    Blur: Transparency,
    Zoom: ViewDetail,
    Path: Draw,
    Pin: Captcha,
    Spot: Flashlight,
    Text: TextIcon,
    Note,
    Image,
};
export const getToolIcon = (tool, iconSet = MakerIcon) => {
    var _a, _b, _c, _d;
    if (!tool) {
        return Icons.CircleIcon;
    }
    const label = (_a = tool.label) !== null && _a !== void 0 ? _a : tool.alias;
    const iconName = (_b = tool.icon) !== null && _b !== void 0 ? _b : `${capitalize(label)}Icon`;
    return (_d = (_c = iconSet[label]) !== null && _c !== void 0 ? _c : Icons[iconName]) !== null && _d !== void 0 ? _d : Icons.CircleIcon;
};
export const ToolIcon = (props) => {
    const { tool, iconSet = MakerIcon } = props;
    const Icon = getToolIcon(tool, iconSet);
    if (!Icon) {
        return null;
    }
    return React.createElement(Icon, null);
};
